import * as types from './types'
import { push } from 'react-router-redux'

export const login = (email, password) => {
  console.log(email, password)
  return (dispatch) => {
    console.log(email, password)
    let body = JSON.stringify({
      auth: {
        email, password
      }
    })
    console.log(body)
    fetch(process.env.REACT_APP_BASE_API + "/login", {
      body,
      method: "POST",
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(
      res => res.json()
    ).then(
      data => {
        dispatch(push("/"))
        dispatch(loginSuccess(data))
      }
    ).catch((err) => {
      console.log(err)
    })
  }
}

export const loginSuccess = data => ({
  type: types.LOGIN_SUCCESS,
  jwt: data['jwt'],
})

export const loginError = data => ({
  type: types.LOGIN_ERROR,
  error: data,
})



// WEBPACK FOOTER //
// ./src/actions/user.js